<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-6 offset-xl-3">
          <card>
            <template slot="header">
              <h4 class="card-title">Recupera password</h4>
              <p v-if="!mailInviata">Riceverai il link per il reset della password al tuo indirizzo email</p>
              <form class="login-form" v-if="!mailInviata">
                <div class="row">
                  <div class="col-12">
                    <fg-input type="text"
                      label="Username"
                      placeholder="Username"
                      v-model="username"
                      :disabled="loading">
                    </fg-input>
                  </div>
                  <div class="col-12">
                    <button type="submit" :disabled="loading" class="btn btn-info btn-fill float-right" @click.prevent="invia">
                      Invia
                    </button>
                  </div>
                </div>
              </form>
              <p v-if="mailInviata">Abbiamo inviato il link per il reset al tuo indirizzo email.</p>
            </template>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6 offset-xl-3" style="padding:0px 30px;">
          <a href="#/login">Torna alla pagina di login</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    data () {
      return {
        loading: false,
        username: '',
        mailInviata: false
      }
    },
    methods: {
      invia: function (event) {
        var me = this
        me.$data.loading = true
        var url = process.env.API_URL + 'auth/user/recovery'
        var method = 'POST'
        var params = {
          username: me.$data.username
        }
        var successFn = function (data) {
          me.$data.mailInviata = true
          me.$data.loading = false
        }
        var errorFn = function (message) {
          me.ajaxErrorFn(message)
          me.$data.loading = false
        }
        me.$root.ajax(url, method, params, successFn, errorFn)
      }
    }
  }

</script>
<style>
.login-form .form-check {
  padding-left: 0px;
}
.login-form .form-check .form-check-label{
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/GeneralViews/UserRecovery.vue